import { createRouter, createWebHashHistory } from 'vue-router'
// import { LoginCallback } from '@okta/okta-vue'
// import { navigationGuard } from '@okta/okta-vue'
import HomeComponent from '@/components/Home'
import LoginComponent from '@/components/Login'
import ProfileComponent from '@/components/Profile'
import MessagesComponent from '@/components/Messages'
import CapabilityComponent from '@/components/CapabilityStart'
import StaffComponent from '@/components/Staff'
import { msalInstance } from "@/authConfig";
import store from "../store/index";


const router = createRouter({
  history: createWebHashHistory(process.env.BASE_URL),
  routes: [
    {
      path: '/',
      component: HomeComponent
    },
    {
      path: '/login',
      component: LoginComponent,
    },
    // {
    //   path: '/login/callback',
    //   component: LoginCallback
    // },
    {
      path: '/profile',
      component: ProfileComponent,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/capability',
      component: CapabilityComponent,
      meta: {
          requiresAuth: true
      }
    },
    {
      path: '/messages',
      component: MessagesComponent,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/staff',
      component: StaffComponent,
      meta: {
        requiresAuth: true
      }
    }
  ]
})

router.beforeEach(async (to,from) => {
  if(to.path != from.path && to.fullPath != "/login"){
    //now check our user
    const currentAccounts = await msalInstance.getAllAccounts();
    try {
        if (currentAccounts.length > 0) {

            let userID = store.state.authentication.user.localAccountId;
            if (userID !== null && typeof userID !== "undefined" && userID !== "") {
                console.log("logged in")
            } else {
              return '/login'
            }
        } else {
          return '/login'
        }
    } catch (ex) {
      console.log(ex, "exception")
        //there was an error, we don't seem to have an account.
    }
  }

  if(to.fullPath == '/login'){
    const currentAccounts = await msalInstance.getAllAccounts();
    try {
      if (currentAccounts.length > 0) {
        let userID = store.state.authentication.user.localAccountId;
        if (userID !== null && typeof userID !== "undefined" && userID !== "") {
          return '/';
        } 
      }
    }catch(ex) {
      console.log(ex,"exception")
    }
  }

})

export default router
